export default {"src":"/_next/static/media/idea-icon.2c64cba3.svg","height":32,"width":32};